import { useEffect, useState } from "react";
import { Desktop } from "../components/Desktop";
import { DrillIntroVideo } from "../components/DrillIntroVideo";
import DrillGoNoGo from "./DrillGoNoGo";
import { getState, haveState, currentState } from '../globalState';


// "retake" indicates whether we were invoked by an assessment (/a/drills-DRILL) or the training page (/d/drills-DRILL)

const DrillGoNoGoIntro = ({ retake }) => {
    const [stateLoaded, setStateLoaded] = useState(haveState);
    const [gameStarted, setGameStarted] = useState(false);
    const [videoPlayed, setVideoPlayed] = useState(false);

    useEffect(() => {
        console.log(`DrillGoNoGoIntro.jsx`);
        getState().then(setStateLoaded(true));
    }, []);

    if (!stateLoaded) {
        // delay until we have state
        return (
            <>
            </>
        )
    }

    if (!videoPlayed && currentState.showVideos)
        return <DrillIntroVideo current="go-no-go" onVideoFinished={() => setVideoPlayed(true)} />;

    if (gameStarted || !currentState.showInstructions)
        return <DrillGoNoGo retake={retake} />;

    // instructions page
    return (
        <>
            <main className="main">
                <section className="drill js-section section">
                    <div className="wrapper">
                        <div className="drill__header">
                            <div className="drill__icon">
                                <img src="/images/go-icon.svg" alt="" />
                            </div>
                            <h2 className="drill__title">Go/No-Go</h2>
                            <div className="drill__list">
                                <div className="drill__item">
                                    <i className="svg-image-about-icon-2-sm" />
                                </div>
                                <div className="drill__item">
                                    <i className="svg-image-about-icon-1-sm" />
                                </div>
                                <div className="drill__item">
                                    <i className="svg-image-about-icon-5-sm" />
                                </div>
                            </div>
                        </div>
                        <div className="drill__subtitle">
                            Assess your inhibition - can you get better at stopping yourself
                            from reacting?
                        </div>
                        <div className="drill__how-to">How to play</div>
                        <div className="drill__body">
                            Start with your left and right index fingers on the home bases.
                            Touch the green targets as quickly as possible, don't touch the red
                            targets.
                        </div>
                        <div className="drill__example">
                            <div style={{ height: "220px" }}>
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                >
                                    <source src="/video/go-no-go.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                </section>
                <Desktop />
            </main>
            <footer className="footer">
                <div className="wrapper">
                    <div className="footer-btns">
                        <button className="footer-btn btn" onClick={() => setGameStarted(true)}>
                            Get to Work
                        </button>
                    </div>
                </div>
            </footer>
        </>
    )
};

export default DrillGoNoGoIntro;
